module.exports = __webpack_public_path__ + "images/no-data-error-msg-793af093.svg";